import * as actions from '../../Action/Tenant/TenantCreatedFetchUser'

export const initialState = {
    userData: null  ,
    loaderStatus:false,
    userDataFailure: null  
}

export default function reducer(state = initialState, action){
    
    switch(action.type){
        case actions.USERDATA : return userData(state,action);
        case actions.LOGGEDINLOADER: return loggedInLoader(state,action)
        case actions.USERDATAFAILURE: return userDataFailure(state,action)

    default: return state 
    }
}

const userData = (state,action) => {
    return {
        ...state,
        userData: action.payload
    }
}

const loggedInLoader =(state,action) => {
    return{
        ...state,
        loaderStatus: action.payload
    }
}

const userDataFailure = (state,action) => {
    return {
        ...state,
        userDataFailure: action.payload
    }
}